/* ============================================================
   OCC — grid / list view toggle (collection pages)
   Checklist: "Appropriate Grid/List Views"

   - Reveals the control only when JS is available.
   - Remembers the choice in localStorage (per browser).
   - Re-applies after Shopify's facet filtering replaces the grid,
     which swaps the <ul> out from under us.
   ============================================================ */
(function () {
  'use strict';

  var KEY = 'occ:collection-view';
  var LIST = 'product-grid--list';

  function readPref() {
    try {
      return localStorage.getItem(KEY) === 'list' ? 'list' : 'grid';
    } catch (e) {
      return 'grid'; // private mode / blocked storage
    }
  }

  function writePref(v) {
    try {
      localStorage.setItem(KEY, v);
    } catch (e) {
      /* non-fatal */
    }
  }

  function grid() {
    return document.getElementById('product-grid');
  }

  function apply(view) {
    var g = grid();
    if (g) g.classList.toggle(LIST, view === 'list');

    document.querySelectorAll('[data-occ-view]').forEach(function (btn) {
      var on = btn.getAttribute('data-occ-view') === view;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function init() {
    var wrap = document.querySelector('[data-occ-viewtoggle]');
    if (!wrap) return;

    wrap.hidden = false; // JS is available, so the control can work
    apply(readPref());

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-occ-view]');
      if (!btn) return;
      var view = btn.getAttribute('data-occ-view');
      writePref(view);
      apply(view);
    });

    // Facet filtering replaces #product-grid; re-apply when it does.
    var host = document.getElementById('ProductGridContainer');
    if (host && 'MutationObserver' in window) {
      new MutationObserver(function () {
        var currentWrap = document.querySelector('[data-occ-viewtoggle]');
        if (currentWrap) currentWrap.hidden = false;
        apply(readPref());
      }).observe(host, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
